import { TrendLevel } from "@/reports/types";
import DataInfoCard from "@/components/DataInfoCard";
import {
  dataInfoCardCss,
  containerCss,
  chartsContainerCss,
} from "@/reports/teacher/common/OverviewDataResults/OverviewDataResults.style";
import WeeklyTrendLevel from "../WeeklyTrendLevel";
import GradeLevelChartRow from "./components/GradeLevelChartRow";

interface TextsReadByGradeLevelProps {
  weeklyTrendLevel: TrendLevel;
  aboveGradeLevel: number;
  atGradeLevel: number;
  belowGradeLevel: number;
  isLoading: boolean;
}

interface TextsReadByGradeLevelContentProps
  extends TextsReadByGradeLevelProps {}

const TextsReadByGradeLevelContent = ({
  weeklyTrendLevel,
  aboveGradeLevel,
  atGradeLevel,
  belowGradeLevel,
  isLoading,
}: TextsReadByGradeLevelContentProps) => {
  const PERCENTAGE_VALUES = [belowGradeLevel, atGradeLevel, aboveGradeLevel];
  const maxValue = PERCENTAGE_VALUES.reduce(
    (a, b) => Math.max(a, b),
    -Infinity,
  );

  return (
    <>
      <div css={containerCss}>
        <div css={chartsContainerCss}>
          <GradeLevelChartRow
            label="Above grade level"
            value={aboveGradeLevel}
            maxValue={maxValue}
            isLoading={isLoading}
          />
          <GradeLevelChartRow
            label="At grade level"
            value={atGradeLevel}
            maxValue={maxValue}
            isLoading={isLoading}
          />
          <GradeLevelChartRow
            label="Below grade level"
            value={belowGradeLevel}
            maxValue={maxValue}
            isLoading={isLoading}
          />
        </div>
        <WeeklyTrendLevel trendLevel={weeklyTrendLevel} isLoading={isLoading} />
      </div>
    </>
  );
};
const TextsReadByGradeLevel = ({
  weeklyTrendLevel,
  aboveGradeLevel,
  atGradeLevel,
  belowGradeLevel,
  isLoading,
}: TextsReadByGradeLevelProps) => {
  return (
    <DataInfoCard
      heading="Texts read by grade levels"
      tooltipDialog={{
        header: "Texts read by grade levels",
        body: "The number of texts that were viewed either at, below, or above your class grade level.",
      }}
      textContent={
        <TextsReadByGradeLevelContent
          aboveGradeLevel={aboveGradeLevel}
          atGradeLevel={atGradeLevel}
          belowGradeLevel={belowGradeLevel}
          weeklyTrendLevel={weeklyTrendLevel}
          isLoading={isLoading}
        />
      }
      additionalStyles={{ containerCss: dataInfoCardCss() }}
    />
  );
};

export default TextsReadByGradeLevel;
